const ENA = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_3017_16622)">
      <mask
        id="mask0_3017_16622"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path d="M20 0H0V20H20V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3017_16622)">
        <path
          d="M10.0004 0.180664C15.3983 0.180664 19.7745 4.56772 19.7745 9.97946C19.7745 15.3912 15.3986 19.7786 10.0007 19.7786C4.60273 19.7786 0.226562 15.3915 0.226562 9.97982C0.226562 4.56808 4.60243 0.180664 10.0004 0.180664Z"
          fill="#111111"
        />
        <path
          d="M10.0011 0C4.50374 0 0.046875 4.46787 0.046875 9.97928C0.046875 15.4906 4.50334 19.9589 10.0007 19.9589C15.498 19.9589 19.9548 15.491 19.9548 9.97964C19.9548 4.46823 15.4984 0 10.0011 0Z"
          fill="url(#paint0_radial_3017_16622)"
          fill-opacity="0.7"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0007 0.364612C4.70515 0.364612 0.411487 4.66859 0.411487 9.97882C0.411487 15.2891 4.70515 19.5933 10.0007 19.5933C15.2962 19.5933 19.5902 15.2894 19.5902 9.97917C19.5902 4.66893 15.2962 0.364612 10.0007 0.364612ZM0.046875 9.97882C0.046875 4.46809 4.5029 0 10.0007 0C15.4984 0 19.9548 4.4681 19.9548 9.97882C19.9548 15.4895 15.4988 19.9579 10.0011 19.9579C4.5033 19.9579 0.046875 15.4895 0.046875 9.97882Z"
          fill="url(#paint1_linear_3017_16622)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.82514 5.33789H7.61305L7.4755 5.49978L3.92529 9.68044L3.67188 9.97891L3.92529 10.2773L7.4755 14.458L7.61305 14.6199H7.82514H14.2167H14.6759V14.1595V11.5018H13.7576V13.6992H8.82934L11.7789 10.28L12.0387 9.97891L11.7789 9.67773L8.82934 6.2586H13.7576V8.45599H14.6759V5.79824V5.33789H14.2167H7.82514ZM7.82786 6.5052L4.878 9.97891L7.82786 13.4526L10.8245 9.97891L7.82786 6.5052Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_3017_16622"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.0222 2.91426) rotate(90) scale(21.041 14.773)"
      >
        <stop offset="0.03125" stop-color="#3A3A3A" />
        <stop offset="1" stop-color="#1C1C1C" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_3017_16622"
        x1="10.0009"
        y1="-0.188759"
        x2="10.0009"
        y2="20.1467"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#111111" />
      </linearGradient>
      <clipPath id="clip0_3017_16622">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ENA;
